var checkAccountEmailInput;
var ns_account_session,
  ns_username,
  ns_cookie_expire,
  ns_account_submit_lock = false;

jQuery(document).ready(function ($) {
  // Hide/Show Account Nav
  if ($(".account-show-nc").length) {
    if (typeof ns_session_type !== "undefined" && ns_session_type == "NC") {
      $(".account-show-nc").removeClass("hide");
    } else {
      $(".account-show-nc").addClass("hide");
    }
  }

  showAccountLogin();

  // new account check just for email
  $("#accountUsernameForm").submit(function (e) {
    e.preventDefault();

    $("[data-my-account-loader]").removeClass("hide");

    $("#usernameAcct").removeClass("is-invalid");

    var accountUsernameForm = document.querySelectorAll(
      "#accountUsernameForm"
    )[0];

    var email = $("#emailAcct").val();
    var usernameInvalid = false;

    //validate for email
    $("#emailAcct").removeClass("d-none");
    $("#emailAcct").attr("required", true);

    if (!email) {
      $("#emailAcct").addClass("is-invalid");
      usernameInvalid = true;
    }

    if (
      !accountUsernameForm.checkValidity() ||
      $("form#accountUsernameForm .is-invalid").length ||
      usernameInvalid
    ) {
      // Form Invalid
      $("[data-my-account-loader]").addClass("hide");
      $("#accountUsernameForm").removeClass("was-validated");
    } else {
      // Form Validated
      checkUsername(email);
    }

    accountUsernameForm.classList.add("was-validated");
  });

  // NC Account Creation Step 1
  $("#accountCreateFormNC-1").submit(function (e) {
    e.preventDefault();

    var accountForm = document.querySelectorAll("#accountCreateFormNC-1")[0];

    $("[data-my-account-loader]").removeClass("hide");

    $("#accountCreateFormNC-1 .alert").addClass("hide");
    $("#accountCreateNCID").removeClass("is-invalid");

    if (
      !accountForm.checkValidity() ||
      $("#accountCreateFormNC-1 .is-invalid").length
    ) {
      // Form Invalid
      console.log("form invalid");
      $("[data-my-account-loader]").addClass("hide");
    } else {
      // Form Validated
      console.log("form valid");

      // Check Account Number
      $.ajax({
        url: "/wp-content/themes/lumos-tidewater/api_helper.php",
        method: "POST",
        contentType: "application/x-www-form-urlencoded",
        data: {
          action: "ns_pending_user_registration",
          accountId: $("#accountCreateNCID").val(),
        },
        success: function (result) {
          console.log(result);
          var response = $.parseJSON(result);
          if (response.Status == "success") {
            // Account Found
            $('*[data-account-creation-options] input[type="radio"]').each(
              function () {
                if ($(this).val() !== "-1") {
                  $(this).parent("label").remove();
                }
              }
            );

            for (var i = 0; i < response.Data.length; i++) {
              var sendMethod =
                '<label class="d-flex align-items-start mb-2"><input type="radio" class="me-2" name="selectTokenContact" value="' +
                response.Data[i].id +
                '" data-type="' +
                response.Data[i].type +
                '" required /> <span>' +
                response.Data[i].type +
                ": " +
                response.Data[i].value +
                "</span></label>";
              $("*[data-account-creation-options]").prepend(sendMethod);
            }

            $('div[data-page-order="2"]').hide();
            $('div[data-page-order="3"]').fadeIn();

            $(".full-loader").addClass("hide");
          } else {
            // Account Not Found
            if (response.Message) {
              // Clean it up if needed
              var eemessage = response.Message.replace(/(<([^>]+)>)/gi, "");

              // Expressions to add links
              var linkexp =
                /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
              var phoneexp = /((\d[\d\-.]*){9,})/g;
              var emailexp = /([a-z0-9._-]+@[a-z0-9.-]+\.[a-z]{2,4})/gi;

              // Convert strings to links
              eemessage = eemessage.replace(linkexp, '<a href="$1">$1</a>');
              eemessage = eemessage.replace(
                phoneexp,
                '<a href="tel:$1">$1</a>'
              );
              eemessage = eemessage.replace(
                emailexp,
                '<a href="mailto:$1">$1</a>'
              );

              $("#accountCreateFormNC-1 .alert").html(eemessage);
            }

            $("#accountCreateFormNC-1 .alert").removeClass("hide");
            $("#accountCreateNCID").addClass("is-invalid");

            $("[data-my-account-loader]").addClass("hide");
          }
        },
      });
    }
    accountForm.classList.add("was-validated");
  });

  // NC Account Creation Step 2
  $("#accountCreateFormNC-2").submit(function (e) {
    e.preventDefault();

    var accountForm = document.querySelectorAll("#accountCreateFormNC-2")[0];

    $("[data-my-account-loader]").removeClass("hide");
    $("#accountCreateFormNC-2 .alert").addClass("hide");

    if (
      !accountForm.checkValidity() ||
      $("#accountCreateFormNC-2 .is-invalid").length
    ) {
      // Form Invalid
      console.log("form invalid");
      $("[data-my-account-loader]").addClass("hide");
    } else {
      // Form Validated
      console.log("form valid");

      // Send a token
      if (
        $('input[type="radio"][name="selectTokenContact"]:checked').val() !==
        "-1"
      ) {
        var contact_id = $(
          'input[type="radio"][name="selectTokenContact"]:checked'
        ).val();
        var contact_type = $(
          'input[type="radio"][name="selectTokenContact"]:checked'
        ).attr("data-type");

        $.ajax({
          url: "/wp-content/themes/lumos-tidewater/api_helper.php",
          method: "POST",
          contentType: "application/x-www-form-urlencoded",
          data: {
            action: "ns_pending_user_sendtoken",
            id: contact_id,
            type: contact_type,
          },
          success: function (result) {
            var response = $.parseJSON(result);
            if (response.Status == "success" && response.Data) {
              $('div[data-page-order="3"]').hide();
              $('div[data-page-order="4"]').fadeIn();

              $("[data-my-account-loader]").addClass("hide");
            } else {
              $("#accountCreateFormNC-2 .alert").removeClass("hide");
              $("[data-my-account-loader]").addClass("hide");
            }
          },
        });
        // No Toke needed, proceed
      } else {
        $('div[data-page-order="3"]').hide();
        $('div[data-page-order="4"]').fadeIn();

        $("[data-my-account-loader]").addClass("hide");
      }
    }

    accountForm.classList.add("was-validated");
  });

  // NC Account Creation Step 3
  $("#accountCreateFormNC-3").submit(function (e) {
    e.preventDefault();

    var accountForm = document.querySelectorAll("#accountCreateFormNC-3")[0];

    $("[data-my-account-loader]").removeClass("hide");
    $("#accountCreateFormNC-3 .alert").addClass("hide");

    $("#ns-create-account-token").removeClass("is-invalid");
    $("#ns-create-account-email").removeClass("is-invalid");
    $("#ns-create-account-password").removeClass("is-invalid");
    $("#ns-create-account-password-confirm").removeClass("is-invalid");

    if (
      !accountForm.checkValidity() ||
      $("#accountCreateFormNC-3 .is-invalid").length
    ) {
      // Form Invalid
      console.log("form invalid");
      $("[data-my-account-loader]").addClass("hide");
    } else {
      // Form Valid
      console.log("form valid");

      $.ajax({
        url: "/wp-content/themes/lumos-tidewater/api_helper.php",
        method: "POST",
        contentType: "application/x-www-form-urlencoded",
        data: {
          action: "ns_username_add",
          token: $("#ns-create-account-token").val(),
          accountId: $("#accountCreateNCID").val(),
          Username: $("#ns-create-account-email").val(),
          Password: $("#ns-create-account-password").val(),
        },
        success: function (result) {
          console.log(result);

          var response = JSON.parse(result);

          var isValidated = false;
          // Look for success response
          if (response.Status == "success") {
            isValidated = true;
          }
          // Look for a false data object
          if ("Data" in response && response.Data == false) {
            isValidated = false;
          }

          if (isValidated) {
            console.log(isValidated);
            $('div[data-page-order="4"]').hide();
            $('div[data-page-order="5"]').fadeIn();

            $("[data-my-account-loader]").addClass("hide");
          } else {
            console.log(isValidated);
            if (response.Entity == "PendingRegistration") {
              $("#ns-create-account-token").addClass("is-invalid");
            } else {
              $("#ns-create-account-token").addClass("is-invalid");
              $("#ns-create-account-email").addClass("is-invalid");
              $("#ns-create-account-password").addClass("is-invalid");
              $("#ns-create-account-password-confirm").addClass("is-invalid");
            }

            $("#accountCreateFormNC-3 .alert").removeClass("hide");
            $("[data-my-account-loader]").addClass("hide");
          }
        },
      });
    }

    accountForm.classList.add("was-validated");
  });

  // VA Account Creation Step 1
  $("#accountCreateFormVA-1").submit(function (e) {
    e.preventDefault();

    var accountForm = document.querySelectorAll("#accountCreateFormVA-1")[0];

    $("[data-my-account-loader]").removeClass("hide");
    $("#accountCreateFormVA-1 .alert").addClass("hide");

    $("#ns-create-account-va-account").removeClass("is-invalid");
    $("#ns-create-account-va-pin").removeClass("is-invalid");

    if (
      !accountForm.checkValidity() ||
      $("#accountCreateFormVA-1 .is-invalid").length
    ) {
      // Form Invalid
      console.log("form invalid");
      $("[data-my-account-loader]").addClass("hide");
    } else {
      // Form Validated
      console.log("form valid");

      $.ajax({
        url: "/wp-content/themes/lumos-tidewater/api_helper.php",
        method: "POST",
        contentType: "application/x-www-form-urlencoded",
        data: {
          action: "ns_validate_token_va",
          accountId: $("#ns-create-account-va-account").val(),
          token: $("#ns-create-account-va-pin").val(),
        },
        success: function (result) {
          var response = $.parseJSON(result);
          if (response.Data) {
            $('div[data-page-order="6"]').hide();
            $('div[data-page-order="7"]').fadeIn();

            $("[data-my-account-loader]").addClass("hide");
          } else {
            $("#ns-create-account-va-account").addClass("is-invalid");
            $("#ns-create-account-va-pin").addClass("is-invalid");

            $("#accountCreateFormVA-1 .alert").removeClass("hide");
            $("[data-my-account-loader]").addClass("hide");
          }
        },
      });
    }

    accountForm.classList.add("was-validated");
  });

  // VA Account Creation Step 2
  $("#accountCreateFormVA-2").submit(function (e) {
    e.preventDefault();

    var accountForm = document.querySelectorAll("#accountCreateFormVA-2")[0];

    $("[data-my-account-loader]").removeClass("hide");
    $("#accountCreateFormVA-2 .alert").addClass("hide");

    $("#ns-create-account-va-first-name").removeClass("is-invalid");
    $("#ns-create-account-va-last-name").removeClass("is-invalid");
    $("#ns-create-account-va-phone").removeClass("is-invalid");
    $("#ns-create-account-va-street-address").removeClass("is-invalid");
    $("#ns-create-account-va-zip-code").removeClass("is-invalid");

    $("#ns-create-account-va-email").removeClass("is-invalid");
    $("#ns-create-account-va-password").removeClass("is-invalid");
    $("#ns-create-account-va-password-confirm").removeClass("is-invalid");

    if (
      !accountForm.checkValidity() ||
      $("#accountCreateFormVA-2 .is-invalid").length
    ) {
      // Form Invalid
      console.log("form invalid");
      $("[data-my-account-loader]").addClass("hide");
    } else {
      // Form Validated
      console.log("form valid");

      $.ajax({
        url: "/wp-content/themes/lumos-tidewater/api_helper.php",
        method: "POST",
        contentType: "application/x-www-form-urlencoded",
        data: {
          action: "ns_username_add_va",
          accountId: $("#ns-create-account-va-account").val(),
          token: $("#ns-create-account-va-pin").val(),
          Username: $("#ns-create-account-va-email").val(),
          Password: $("#ns-create-account-va-password").val(),
          FirstName: $("#ns-create-account-va-first-name").val(),
          LastName: $("#ns-create-account-va-last-name").val(),
          Phone: $("#ns-create-account-va-phone").val(),
          Address: $("#ns-create-account-va-street-address").val(),
          Zip: $("#ns-create-account-va-zip-code").val(),
        },
        success: function (result) {
          var response = $.parseJSON(result);
          if (response.Status == "success" && response.Data) {
            $('div[data-page-order="7"]').hide();
            $('div[data-page-order="5"]').fadeIn();

            $("[data-my-account-loader]").addClass("hide");
          } else {
            $("#ns-create-account-va-first-name").addClass("is-invalid");
            $("#ns-create-account-va-last-name").addClass("is-invalid");
            $("#ns-create-account-va-phone").addClass("is-invalid");
            $("#ns-create-account-va-street-address").addClass("is-invalid");
            $("#ns-create-account-va-zip-code").addClass("is-invalid");

            $("#ns-create-account-va-email").addClass("is-invalid");
            $("#ns-create-account-va-password").addClass("is-invalid");
            $("#ns-create-account-va-password-confirm").addClass("is-invalid");

            $("#accountCreateFormVA-2 .alert").removeClass("hide");
            $("[data-my-account-loader]").addClass("hide");
          }
        },
      });
    }
    accountForm.classList.add("was-validated");
  });

  // Change My Account view pages
  $(".paged-section button[data-goto-page]").click(function (e) {
    e.preventDefault();
    var gotopage = $(this).attr("data-goto-page"),
      hidepage = $(this).attr("data-hide-page"),
      $pagedSection = $(this).parents(".paged-section");

    // console.log(gotopage, hidepage);

    $pagedSection.find('[data-page-order="' + hidepage + '"]').hide();
    $pagedSection.find('[data-page-order="' + gotopage + '"]').fadeIn();
  });

  // Change the zip code for Chat/My Account
  $("button[data-change-zip]").click(function (e) {
    e.preventDefault();
    changeAccountZip();
  });

  // Login Account Submit
  $("#ns-login-account").submit(function (e) {
    console.log("account-login");

    var accountForm = document.querySelectorAll("#ns-login-account")[0];

    if (!accountForm.checkValidity()) {
      e.preventDefault();
      e.stopPropagation();
    } else {
      console.log("form valid");

      $("[data-my-account-loader]").removeClass("hide");

      if (ns_account_submit_lock) {
        e.preventDefault();
        console.log("submit lock");

        // Clear banner cookie
        localStorage.setItem("close_account_banner", "");

        var ns_un = $("#ns_username").val().trim();
        var ns_pw = $("#ns_password").val();
        //
        // nsLoginSession(ns_un, ns_pw);

        $.ajax({
          url: "/wp-content/themes/lumos-tidewater/api_helper.php",
          type: "GET",
          // dataType: "json",
          data: {
            action: "get_ns_myaccount_url",
          },
          success: function (result) {
            console.log(result);
            var accountURL = result;

            var accountAuthURL = accountURL + "api/user/Authenticate";
            // var accountPageURL = accountURL+"MyAccount";

            var accountLoginURL =
              accountAuthURL +
              "?logIn=" +
              encodeURIComponent(ns_un) +
              "&password=" +
              encodeURIComponent(ns_pw);

            $.ajax({
              type: "GET",
              url: accountLoginURL,
              dataType: "jsonp",
              xhrFields: {
                withCredentials: true,
              },
              crossDomain: true,
            })
              .done(function () {
                // alert("success");
              })
              .fail(function (e) {
                // console.log(e);
                ns_account_submit_lock = false;
                $("#ns-login-account").submit();
                // console.log('submit form');
              });
          },
        });
      } else {
        console.log("submit unlock");
      }
    }

    $(this).addClass("was-validated");
  });

  // Forgot username submit
  $("#ns-forgot-username-form").submit(function (e) {
    e.preventDefault();

    var accountForm = document.querySelectorAll("#ns-forgot-username-form")[0];

    $("[data-my-account-loader]").removeClass("hide");
    $("#ns-forgot-username-form .alert").addClass("hide");

    $("#ns-forgot-username-form .alert-success").addClass("hide");
    $("#ns-forgot-username-form .alert-danger").addClass("hide");

    if (
      !accountForm.checkValidity() ||
      $("#ns-forgot-username-form .is-invalid").length
    ) {
      // Form Invalid
      console.log("form invalid");
      $("[data-my-account-loader]").addClass("hide");
    } else {
      // Form Validated
      console.log("form valid");

      $.ajax({
        url: "/wp-content/themes/lumos-tidewater/api_helper.php",
        method: "POST",
        contentType: "application/x-www-form-urlencoded",
        data: {
          action: "forgot_username",
          account: $("#ns-forgot-username-account").val(),
          pin: $("#ns-forgot-username-pin").val(),
        },
        success: function (result) {
          // console.log(result);
          var response = $.parseJSON(result);
          if (response.Data) {
            $("#ns-forgot-username-form .alert-success").removeClass("hide");

            $("#ns-forgot-username-account").val("");
            $("#ns-forgot-username-pin").val("");

            $("[data-my-account-loader]").addClass("hide");
          } else {
            $("#ns-forgot-username-form .alert-danger").removeClass("hide");

            $("#ns-forgot-username-account").val("");
            $("#ns-forgot-username-pin").val("");

            $("[data-my-account-loader]").addClass("hide");
          }
        },
        error: function () {
          $("#ns-forgot-username-form .alert-danger").removeClass("hide");

          $("#ns-forgot-username-account").val("");
          $("#ns-forgot-username-pin").val("");

          $("[data-my-account-loader]").addClass("hide");
        },
      });
    }

    accountForm.classList.add("was-validated");
  });

  // Forgot password submit
  $("#ns-forgot-password-form").submit(function (e) {
    e.preventDefault();

    var accountForm = document.querySelectorAll("#ns-forgot-password-form")[0];

    $("[data-my-account-loader]").removeClass("hide");
    $("#ns-forgot-username-form .alert").addClass("hide");

    $("#ns-forgot-password-form .alert-success").addClass("hide");
    $("#ns-forgot-password-form .alert-danger").addClass("hide");

    if (
      !accountForm.checkValidity() ||
      $("#ns-forgot-password-form .is-invalid").length
    ) {
      // Form Invalid
      console.log("form invalid");
      $("[data-my-account-loader]").addClass("hide");
    } else {
      // Form Validated
      console.log("form valid");

      $.ajax({
        url: "/wp-content/themes/lumos-tidewater/api_helper.php",
        method: "POST",
        contentType: "application/x-www-form-urlencoded",
        data: {
          action: "forgot_password",
          username: $("#ns-forgot-password-email").val(),
        },
        success: function (result) {
          // console.log(result);
          var response = $.parseJSON(result);
          if (response.Status == "success") {
            $("#ns-forgot-password-form .alert-success").removeClass("hide");

            $("#ns-forgot-password-email").val("");

            $("[data-my-account-loader]").addClass("hide");
          } else {
            $("#ns-forgot-password-form .alert-danger").removeClass("hide");

            $("#ns-forgot-password-email").val("");

            $("[data-my-account-loader]").addClass("hide");
          }
        },
        error: function () {
          $("#ns-forgot-password-form .alert-danger").removeClass("hide");

          $("#ns-forgot-password-email").val("");

          $("[data-my-account-loader]").addClass("hide");
        },
      });
    }

    accountForm.classList.add("was-validated");
  });

  // checkAccountEmailInput = function () {
  //   // Hide all relevant prompts and login forms
  //   $("[data-username-entry-prompt]").each(function () {
  //     $(this).addClass("hide");
  //   });
  //   $("[data-legacy-account-login]").each(function () {
  //     $(this).addClass("hide");
  //   });
  //   $("[data-newstack-account-login]").each(function () {
  //     $(this).addClass("hide");
  //   });

  //   showAccountLogin();
  // };

  // checkAccountEmailInput();

  function changeAccountZip() {
    $("[data-legacy-account-login]").each(function () {
      $(this).addClass("hide");
    });
    $("[data-newstack-account-login]").each(function () {
      $(this).addClass("hide");
    });

    $("[data-username-entry-prompt]").each(function () {
      $(this).removeClass("hide");
    });
    localStorage.removeItem("user_account_login_type");
    localStorage.removeItem("user_account_email");
  }

  function checkUsername(email) {
    // check NS api for username, then check SF api for username
    $.ajax({
      url: "/wp-content/themes/lumos-tidewater/api_helper.php",
      type: "GET",
      contentType: "application/x-www-form-urlencoded",
      data: {
        action: "check_username",
        username: email,
      },
      success: function (result) {
        var response = jQuery.parseJSON(result);

        if (response.Status === "success" && response.Data == true) {
          // is ns account
          localStorage.setItem("user_account_login_type", "legacy");
          localStorage.setItem("user_account_email", email);
          showAccountLogin("legacy");
        } else {
          // check if sf username

          var tokenExpiration = Cookies.get("lumos_sftoken_timeout");
          // get token for sf api if not already stored
          if (!localStorage.getItem("lumos_sftoken") || !tokenExpiration) {
            $.ajax({
              url: "/wp-admin/admin-ajax.php",
              type: "POST",
              cache: false,
              async: false,
              data: {
                action: "sf_get_token",
              },
              success: function (result) {
                // console.log('Access Token:', result);
                if (result) {
                  var token = JSON.parse(result);
                  // stash access token
                  localStorage.setItem("lumos_sftoken", token.access_token);

                  // Set token expiration
                  var tokenExpiresMin = 85; // Expires in 85 minutes of the 90 minute token
                  var tokenExpries = (1 / 24 / 60) * tokenExpiresMin;
                  Cookies.set("lumos_sftoken_timeout", tokenExpiresMin, {
                    expires: tokenExpries,
                  });
                } else {
                  // token issue
                  showAccountLogin("error");
                }
              },
              error: function (request, status, error) {
                // token issue
                showAccountLogin("error");
              },
            });
          }

          if (localStorage.getItem("lumos_sftoken")) {
            $.ajax({
              url: "/wp-admin/admin-ajax.php",
              type: "GET",
              contentType: "application/x-www-form-urlencoded",
              data: {
                action: "sf_get_username",
                username: email,
                token: localStorage.getItem("lumos_sftoken"),
              },
              success: function (result) {
                try {
                  var response = jQuery.parseJSON(result);
                  if (Array.isArray(response) && response.length > 0) {
                    if (response[0].errorCode) {
                      showAccountLogin("error");
                      return;
                    }
                  }
                  
                  // Check if the searchRecords array has any users
                  if (
                    response.searchRecords &&
                    response.searchRecords.length > 0
                  ) {
                    localStorage.setItem(
                      "user_account_login_type",
                      "salesforce"
                    );
                    localStorage.setItem("user_account_email", email);

                    showAccountLogin("salesforce");
                  } else {
                    showAccountLogin("legacy");
                  }
                } catch (error) {
                  console.error("Error parsing response: " + error);
                  showAccountLogin("error");
                }
              },
              error: function (xhr, status, error) {
                console.error("Error checking username: " + error);
                showAccountLogin("error");
              },
            });
          }
        }
      },
      error: function (xhr, status, error) {
        console.error("Error checking username: " + error);
        showAccountLogin("error");
      },
    });
  }

  function showAccountLogin(accountType = "") {
    console.log("Showing account login");
    // let accountType = localStorage.getItem("user_account_login_type");
    if(localStorage.getItem("user_account_login_type") !== null) {
      accountType = localStorage.getItem("user_account_login_type");
      if(localStorage.getItem("user_account_email") !== null){
        $("#ns_username").val(localStorage.getItem("user_account_email"));
      }
    }
      
    if (accountType === "salesforce") {
      $("[data-username-entry-prompt]").each(function () {
        $(this).addClass("hide");
      });
      $("[data-newstack-account-login]").each(function () {
        $(this).removeClass("hide");
      });
      $("[data-username-error]").addClass("hide");
      $("[data-no-result]").addClass("hide");
    } else if (accountType === "legacy") {
      $("[data-username-entry-prompt]").each(function () {
        $(this).addClass("hide");
      });
      $("[data-legacy-account-login]").each(function () {
        $(this).removeClass("hide");
      });
      $("[data-username-error]").addClass("hide");
      $("[data-no-result]").addClass("hide");
    } else if (accountType === "error") {
      $("[data-username-entry-prompt]").each(function () {
        $(this).removeClass("hide");
      });
      $("[data-legacy-account-login]").each(function () {
        $(this).addClass("hide");
      });
      $("[data-newstack-account-login]").each(function () {
        $(this).addClass("hide");
      });
      $("[data-username-error]").each(function () {
        $(this).removeClass("hide");
      });
      $("[data-no-result]").addClass("hide");
      $("[data-enter-email]").addClass("hide");
      $("#accountUsernameForm").removeClass("was-validated");
    } else if (accountType === "none") {
      // no username found, show a message
      $("[data-username-entry-prompt]").each(function () {
        $(this).removeClass("hide");
      });
      $("[data-username-error]").addClass("hide");
      $("[data-enter-email]").addClass("hide");
      $("[data-no-result]").removeClass("hide");
      $("#accountUsernameForm").removeClass("was-validated");
    }else{
      $("[data-username-entry-prompt]").each(function () {
        $(this).removeClass("hide");
      });
      $("[data-username-error]").addClass("hide");
      $("[data-enter-email]").removeClass("hide");
      $("[data-no-result]").addClass("hide");
      $("#accountUsernameForm").removeClass("was-validated");
    }

    $("[data-my-account-loader]").addClass("hide");
  }
});
